import { render, staticRenderFns } from "./XlsItem.vue?vue&type=template&id=b3d659d4&scoped=true"
import script from "./XlsItem.vue?vue&type=script&lang=js"
export * from "./XlsItem.vue?vue&type=script&lang=js"
import style0 from "./XlsItem.vue?vue&type=style&index=0&id=b3d659d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d659d4",
  null
  
)

export default component.exports